var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.75 194.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e5c9c;}.cls-2{fill:#163f69;}.cls-3{fill:#4f8cca;}.cls-4{fill:#231f20;}.cls-5{fill:#8d1922;}.cls-6{fill:#4b1618;}.cls-7{fill:#c72330;}.cls-8{fill:#c7212e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.05 22.92 54.78 30.57 68.04 38.23 68.05 22.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.12 7.73 107.86 15.38 121.11 23.04 121.12 7.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.38 15.39 121.12 23.04 134.37 30.7 134.38 15.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "121.12 23.04 134.38 15.39 121.13 7.73 121.12 23.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "134.26 47.69 121 55.34 134.25 63 134.26 47.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "107.84 0.06 94.58 7.7 107.84 15.36 107.84 0.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "107.83 15.36 121.09 7.71 107.83 0.05 107.83 15.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.3 0 68.03 7.65 81.29 15.31 81.3 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.56 7.67 81.3 15.31 94.55 22.97 94.56 7.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.54 22.97 107.8 15.32 94.54 7.66 94.54 22.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.29 15.31 94.55 7.66 81.3 0 81.29 15.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.08 7.65 54.81 15.3 68.07 22.96 68.08 7.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.07 22.96 81.34 15.31 68.08 7.65 68.07 22.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.79 30.57 68.05 22.93 54.79 15.26 54.79 30.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.36 76.54 121.09 84.19 134.35 91.85 134.36 76.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.07 84.15 107.81 91.8 121.06 99.46 121.07 84.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "121.07 99.47 134.33 91.82 121.07 84.16 121.07 99.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.63 84.16 81.37 91.81 94.62 99.47 94.63 84.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "107.89 91.83 94.63 99.48 107.88 107.14 107.89 91.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "107.87 107.13 121.13 99.48 107.88 91.82 107.87 107.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.62 99.47 107.89 91.83 94.63 84.16 94.62 99.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.08 84.11 54.82 91.76 68.08 99.42 68.08 84.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.08 99.42 81.34 91.78 68.09 84.11 68.08 99.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.36 91.74 68.1 99.38 81.35 107.05 81.36 91.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.36 107.05 94.62 99.4 81.36 91.74 81.36 107.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "54.83 30.57 41.56 38.22 54.82 45.88 54.83 30.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "54.82 45.89 68.08 38.24 54.83 30.58 54.82 45.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.8 45.85 41.53 53.49 54.79 61.16 54.8 45.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.54 53.5 54.8 45.85 41.54 38.19 41.54 53.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "54.83 61.16 41.57 68.81 54.83 76.47 54.83 61.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.09 68.83 54.83 76.47 68.09 84.14 68.09 68.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "54.83 76.47 68.09 68.82 54.84 61.16 54.83 76.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.57 68.81 54.84 61.16 41.58 53.5 41.57 68.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.79 91.74 68.05 84.09 54.79 76.43 54.79 91.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "160.75 124.18 174.01 116.53 160.75 108.87 160.75 124.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "107.67 139.37 120.93 131.72 107.68 124.06 107.67 139.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "94.41 131.71 107.67 124.06 94.42 116.4 94.41 131.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "107.67 124.06 94.41 131.71 107.67 139.37 107.67 124.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "120.95 147.05 134.21 139.4 120.95 131.74 120.95 147.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "120.97 131.75 107.71 139.39 120.96 147.05 120.97 131.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "147.5 147.1 160.76 139.45 147.5 131.79 147.5 147.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "134.24 139.44 147.5 131.79 134.24 124.13 134.24 139.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "134.26 124.14 121 131.78 134.25 139.44 134.26 124.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "147.5 131.79 134.24 139.44 147.5 147.1 147.5 131.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "160.72 139.45 173.98 131.8 160.72 124.14 160.72 139.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "160.72 124.14 147.46 131.79 160.71 139.45 160.72 124.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "174.01 116.53 160.75 124.18 174 131.84 174.01 116.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "94.44 70.56 107.7 62.91 94.44 55.25 94.44 70.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "107.72 62.95 120.99 55.3 107.73 47.64 107.72 62.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "107.73 47.63 94.47 55.28 107.72 62.94 107.73 47.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "134.16 62.94 147.43 55.29 134.17 47.63 134.16 62.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "120.9 55.27 134.16 47.62 120.91 39.96 120.9 55.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "120.92 39.97 107.66 47.62 120.92 55.28 120.92 39.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "134.17 47.63 120.91 55.27 134.16 62.94 134.17 47.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "160.71 62.99 173.97 55.34 160.72 47.68 160.71 62.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "160.71 47.68 147.45 55.33 160.7 62.99 160.71 47.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "173.97 116.53 187.23 108.88 173.97 101.22 173.97 116.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "173.97 101.22 160.71 108.86 173.96 116.52 173.97 101.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "174 101.25 187.26 93.61 174 85.94 174 101.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "187.26 93.6 174 101.25 187.25 108.91 187.26 93.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "173.96 85.94 187.22 78.29 173.97 70.63 173.96 85.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "160.7 78.28 173.96 70.63 160.71 62.97 160.7 78.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "173.97 70.63 160.7 78.28 173.96 85.94 173.97 70.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "187.22 78.29 173.96 85.94 187.21 93.6 187.22 78.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "174.01 55.36 160.75 63.01 174 70.67 174.01 55.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "147.46 55.33 160.72 47.68 147.46 40.02 147.46 55.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "147.48 40.02 134.22 47.67 147.47 55.33 147.48 40.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.73,194.81q-7.19,0-11-4T0,179.44a17.36,17.36,0,0,1,1.15-6.53,14.18,14.18,0,0,1,3.15-4.86,13.08,13.08,0,0,1,4.77-3,17.26,17.26,0,0,1,6-1,19.73,19.73,0,0,1,3.41.27,23.13,23.13,0,0,1,2.68.64,12.44,12.44,0,0,1,1.92.75c.51.25.88.45,1.11.59l-1.92,5.37a17,17,0,0,0-3.17-1.24A15.21,15.21,0,0,0,15,169.9a9.09,9.09,0,0,0-3,.51,6.92,6.92,0,0,0-2.6,1.64A8.24,8.24,0,0,0,7.58,175a12.32,12.32,0,0,0-.68,4.34,15.45,15.45,0,0,0,.45,3.82,8.08,8.08,0,0,0,1.44,3,6.91,6.91,0,0,0,2.62,2,9.29,9.29,0,0,0,3.92.75,18.5,18.5,0,0,0,2.6-.17,19.8,19.8,0,0,0,2-.41,10.06,10.06,0,0,0,1.58-.53l1.23-.55,1.83,5.32a15.14,15.14,0,0,1-4,1.53A22.78,22.78,0,0,1,14.73,194.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.16,183.58a13.12,13.12,0,0,1-.81,4.8,9.7,9.7,0,0,1-2.23,3.46,9.16,9.16,0,0,1-3.35,2.1,12.25,12.25,0,0,1-4.19.71,11.91,11.91,0,0,1-4.11-.71,9.41,9.41,0,0,1-3.37-2.1,9.65,9.65,0,0,1-2.27-3.46,12.7,12.7,0,0,1-.83-4.8,12.31,12.31,0,0,1,.86-4.8,10.19,10.19,0,0,1,2.31-3.48,9.39,9.39,0,0,1,3.38-2.12,11.55,11.55,0,0,1,4-.71,11.91,11.91,0,0,1,4.11.71,9.19,9.19,0,0,1,3.37,2.12,10,10,0,0,1,2.27,3.48A12.7,12.7,0,0,1,48.16,183.58Zm-16.22,0a9.53,9.53,0,0,0,.38,2.82,6.47,6.47,0,0,0,1.1,2.16,4.94,4.94,0,0,0,1.77,1.4,5.63,5.63,0,0,0,2.39.49A5.72,5.72,0,0,0,40,190a5,5,0,0,0,1.78-1.4,6.47,6.47,0,0,0,1.1-2.16,9.53,9.53,0,0,0,.38-2.82,9.66,9.66,0,0,0-.38-2.84,6.48,6.48,0,0,0-1.1-2.18A4.84,4.84,0,0,0,40,177.17a5.57,5.57,0,0,0-2.38-.49,5.35,5.35,0,0,0-2.39.5,5.08,5.08,0,0,0-1.77,1.41,6.58,6.58,0,0,0-1.1,2.18A9.55,9.55,0,0,0,31.94,183.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.79,173c.37.68.8,1.51,1.28,2.5s1,2.07,1.5,3.22,1,2.34,1.56,3.55l1.44,3.4,1.45-3.4c.51-1.21,1-2.39,1.55-3.55s1-2.22,1.51-3.22.91-1.82,1.27-2.5h4.36q.3,2.11.57,4.74c.17,1.75.32,3.57.46,5.46s.25,3.79.37,5.69.21,3.69.29,5.37H70.74q-.1-3.1-.25-6.75c-.1-2.43-.26-4.89-.46-7.36L68.8,183c-.45,1-.9,2.09-1.34,3.13s-.87,2-1.28,3-.76,1.76-1,2.44H61.79c-.28-.68-.63-1.49-1-2.44s-.84-2-1.28-3S58.58,184,58.13,183l-1.23-2.85c-.2,2.47-.36,4.93-.46,7.36s-.18,4.68-.24,6.75H51.54c.08-1.68.17-3.47.29-5.37s.23-3.8.36-5.69.29-3.71.46-5.46.37-3.33.57-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.3,173c.37.68.8,1.51,1.28,2.5s1,2.07,1.51,3.22,1,2.34,1.55,3.55l1.44,3.4c.46-1.06.94-2.2,1.45-3.4s1-2.39,1.55-3.55,1-2.22,1.51-3.22.91-1.82,1.28-2.5h4.35c.21,1.41.39,3,.57,4.74s.33,3.57.46,5.46.25,3.79.37,5.69.21,3.69.29,5.37H98.25c-.06-2.07-.15-4.32-.25-6.75s-.25-4.89-.46-7.36L96.31,183c-.45,1-.9,2.09-1.34,3.13s-.86,2-1.27,3-.76,1.76-1,2.44H89.31l-1-2.44c-.41-1-.84-2-1.28-3S86.1,184,85.64,183l-1.23-2.85c-.2,2.47-.35,4.93-.46,7.36s-.18,4.68-.24,6.75H79.05c.08-1.68.18-3.47.29-5.37s.23-3.8.37-5.69.28-3.71.46-5.46.36-3.33.56-4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.43,194.22c-.24-.74-.49-1.5-.76-2.28l-.82-2.32h-8.3c-.26.77-.53,1.55-.8,2.33s-.52,1.54-.76,2.27h-5q1.2-3.43,2.28-6.35t2.11-5.49c.69-1.72,1.36-3.35,2-4.89s1.36-3.05,2.08-4.53h4.53c.7,1.48,1.39,3,2.07,4.53s1.36,3.17,2,4.89,1.39,3.55,2.11,5.49,1.47,4.06,2.28,6.35Zm-5.75-16.44c-.1.31-.26.73-.47,1.26s-.44,1.14-.7,1.84-.55,1.46-.88,2.3-.65,1.72-1,2.63h6.08c-.33-.92-.64-1.8-1-2.64s-.59-1.61-.86-2.3l-.73-1.84C116,178.5,115.81,178.08,115.68,177.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M138.29,189.15a10,10,0,0,0,2.32-.23,4.36,4.36,0,0,0,1.47-.64,2.1,2.1,0,0,0,.76-1,3.45,3.45,0,0,0,.22-1.23,2.86,2.86,0,0,0-1.37-2.41,19.53,19.53,0,0,0-4.68-2.07c-1-.34-1.93-.73-2.9-1.17a10.52,10.52,0,0,1-2.59-1.66,7.7,7.7,0,0,1-1.88-2.43,7.61,7.61,0,0,1-.72-3.47,8.59,8.59,0,0,1,.76-3.68,8,8,0,0,1,2.18-2.79,10,10,0,0,1,3.4-1.77,15.4,15.4,0,0,1,4.52-.61,18.18,18.18,0,0,1,8.73,2l-1.92,5.24a17.9,17.9,0,0,0-2.75-1.13,11.74,11.74,0,0,0-3.64-.49,6.7,6.7,0,0,0-3.43.66,2.24,2.24,0,0,0-1,2,2.4,2.4,0,0,0,.38,1.37,3.79,3.79,0,0,0,1.09,1,11.11,11.11,0,0,0,1.62.81c.61.24,1.28.49,2,.74,1.53.57,2.87,1.13,4,1.68a10.91,10.91,0,0,1,2.84,1.94,7,7,0,0,1,1.68,2.6,10.41,10.41,0,0,1,.55,3.62,7.69,7.69,0,0,1-2.89,6.41c-1.93,1.52-4.84,2.27-8.73,2.27a23.73,23.73,0,0,1-3.54-.23A25.24,25.24,0,0,1,132,194a15.45,15.45,0,0,1-2.08-.73,12.67,12.67,0,0,1-1.47-.72l1.87-5.28a17.39,17.39,0,0,0,3.26,1.3A17,17,0,0,0,138.29,189.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.07,194.22V173h14.35v4h-9.57v4.17h8.5v3.93h-8.5v5.12h10.28v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.92,194.22c-1.37-2.43-2.86-4.84-4.45-7.21a74.92,74.92,0,0,0-5.09-6.72v13.93h-4.73V173h3.9c.67.68,1.42,1.51,2.24,2.49s1.65,2,2.5,3.14,1.69,2.27,2.53,3.47,1.62,2.34,2.36,3.45V173h4.75v21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M201.64,190.57a7,7,0,0,0,1.67-.17,3,3,0,0,0,1.06-.46,1.51,1.51,0,0,0,.55-.69,2.52,2.52,0,0,0,.15-.89,2,2,0,0,0-1-1.73,13.91,13.91,0,0,0-3.37-1.49c-.7-.25-1.39-.53-2.09-.84a7.86,7.86,0,0,1-1.87-1.2,5.73,5.73,0,0,1-1.35-1.75,5.44,5.44,0,0,1-.52-2.5,6.31,6.31,0,0,1,.55-2.65,5.6,5.6,0,0,1,1.57-2,7,7,0,0,1,2.45-1.27,10.91,10.91,0,0,1,3.25-.45,13.47,13.47,0,0,1,3.71.46,13.05,13.05,0,0,1,2.58,1l-1.38,3.77a13,13,0,0,0-2-.82,8.7,8.7,0,0,0-2.62-.35,4.76,4.76,0,0,0-2.47.48,1.59,1.59,0,0,0-.75,1.45,1.74,1.74,0,0,0,.27,1,2.93,2.93,0,0,0,.79.72,6.6,6.6,0,0,0,1.16.58l1.46.54c1.1.41,2.06.81,2.88,1.21a7.69,7.69,0,0,1,2,1.39,5.11,5.11,0,0,1,1.21,1.87,7.46,7.46,0,0,1,.4,2.61,5.54,5.54,0,0,1-2.08,4.62q-2.09,1.63-6.29,1.64a17.86,17.86,0,0,1-2.55-.17,17.29,17.29,0,0,1-2-.41,11.65,11.65,0,0,1-1.5-.53,9.58,9.58,0,0,1-1.06-.52l1.35-3.8a11.73,11.73,0,0,0,2.35.93A12,12,0,0,0,201.64,190.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M213.69,194.22V173h14.36v4h-9.57v4.17H227v3.93h-8.49v5.12h10.27v4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommaLogo);
export default __webpack_public_path__ + "static/media/comma-logo.2c200699479d63ebdd5c4d56229d12f0.svg";
export { ForwardRef as ReactComponent };